import PropTypes from 'prop-types';
import {useEffect, useState} from 'react';
import {useLocation, useNavigate, matchPath} from 'react-router-dom';
// @mui
import {Collapse, Tooltip} from '@mui/material';
// hooks
import useActiveLink from '../../../hooks/useActiveLink';
//
import NavItem from './NavItem';

// ----------------------------------------------------------------------

NavList.propTypes = {
    data: PropTypes.object,
    depth: PropTypes.number,
    hasChild: PropTypes.bool,
};

/**
 * Da li je otvorena stavka iz ove grupe (ili neke pod njom).
 * Putanja grupe često nije prefiks putanja njene dece - „Artikli" stoji na /priceList,
 * a deca su /items/*. Bez ove provere grupa se zatvori čim se otvori takvo dete, pa
 * operater izgubi mesto u meniju.
 */
const hasActiveDescendant = (children, pathname) =>
    (children || []).some((child) =>
        (!!child.path && !!matchPath({path: child.path, end: false}, pathname))
        || hasActiveDescendant(child.children, pathname)
    );

export default function NavList({operator, data, depth, hasChild, isPrimary}) {
    const {pathname} = useLocation();
    const {active: selfActive, isExternalLink} = useActiveLink(data.path);
    const active = selfActive || hasActiveDescendant(data.children, pathname);

    const [open, setOpen] = useState(active);

    const navigate = useNavigate();

    const handleClick = () => {
        if (!hasChild && data.path && !isExternalLink) {
            navigate(data.path);
        } else {
            handleToggle();
        }
    };

    // Grupa u kojoj je otvorena stranica ostaje razvijena i posle prelaska na drugu
    // adresu, da operater vidi gde se nalazi. Ručno sklapanje i dalje radi - efekat
    // se pokreće tek na sledeću promenu adrese.
    useEffect(() => {
        if (active) {
            handleOpen();
        } else {
            handleClose();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname]);

    const handleToggle = () => {
        setOpen(!open);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    return (
        <>
            <NavItem
                item={data}
                depth={depth}
                open={open}
                active={active}
                isExternalLink={isExternalLink}
                onClick={handleClick}
            />


            {hasChild && (
                <Collapse in={open} unmountOnExit>
                    <NavSubList operator={operator} data={data.children} depth={depth} isPrimary={isPrimary}/>
                </Collapse>
            )}
        </>
    );
}

// ----------------------------------------------------------------------

NavSubList.propTypes = {
    data: PropTypes.array,
    depth: PropTypes.number,
};

function NavSubList({operator, data, depth, isPrimary}) {
    data = data.filter(value => {
        if (value.needPrimaryUser === undefined || value.needPrimaryUser === false) {
            return true
        }
        return isPrimary;
    })

    return (
        <>
            {data.map((list) => {
                if (list.title === "Dodavanje mesečne karte" && operator !== 0) {
                    return null;
                }

                return (
                    <NavList key={list.title + list.path} data={list} depth={depth + 1} hasChild={!!list.children}/>
                );
            })}
        </>
    );
}

